import ContactGame from "./ContactGame";
import "./Contact.css"

function Contact() {
    return(
        <div className="contact-wrapper">
            <ContactGame />
        </div>
    );
}

export default Contact;